module.exports = __webpack_public_path__ + "img/label-5A4.9847be88.jpeg";